<template>
	<section class="container invoice-form-component">
		<form>
			<div class="invoice-form-card-header header">{{ invoice ? 'Edit' : 'Create' }} Details</div>
			<div class="card-content content">
				<div class="field">
					<div class="field-body">
						<label class="label">Order Search</label>
						<b-field>
							<b-autocomplete
								expanded
								v-model="orderSearchKeyword"
								@select="option => form.order_search = option"
								:data="filteredOrderSearch"
								field="data"
								placeholder="Search Order"
								@typing="query => getOrderSearch()"
							></b-autocomplete>
						</b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Approved By</label>
						<b-field>
				            <b-select placeholder="Select a User" v-model="form.approved_by" :disabled="!canManageInvoices" expanded>
				            	<option :value="null">Select Person</option>
				                <option :value="user.id" v-for="(user, key) in users">{{ user.first_name }}</option>
				            </b-select>
				        </b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Order Number</label>
						<b-field>
				            <b-input v-model="form.order_number"></b-input>
				        </b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Invoice From</label>
						<b-field>
							<b-autocomplete
								expanded
								v-model="invoiceFromKeyword"
								@select="option => form.invoice_from = option"
								:data="filteredInvoiceFrom"
								field="data"
								placeholder="Search Organization"
								@typing="query => getInvoiceFrom()"
							></b-autocomplete>
				        </b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Invoice Number</label>
						<b-field>
				            <b-input v-model="form.invoice_number"></b-input>
				        </b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Invoice Date</label>
						<b-field>
							<b-datepicker
								icon="calendar"
								v-model="form.invoice_date"
				                trap-focus>
				            </b-datepicker>
				        </b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Invoice Value</label>
						<b-field>
				            <b-input v-model="form.invoice_value"></b-input>
				        </b-field>
					</div>
				</div>
				<div class="field">
					<div class="field-body">
						<label class="label">Notes</label>
						<b-field>
							<b-input type="textarea" v-model="form.notes"></b-input>
				        </b-field>
					</div>
				</div>
				<!-- <div class="field">
					<div class="field-body">
						<label class="label" style="width:200px;">Tags</label>
						<div style="width:100%;">
              				<tags-input allow-new placeholder="Select Tag" :values.sync="form.tags" expanded />
						</div>
					</div>
				</div> -->
				<base-tag-input
					:attach-mode="invoice ? true : false"
					:value.sync="form.tags"
					model-type="invoice"
					:model-id="invoice ? invoice.id : null"
					allow-new
					horizontal
				/>
			</div>
			<div class="card-footer footer">
				<button type="button" class="button is-info" @click="save">{{ invoice ? 'UPDATE' : 'SAVE' }}</button>
				<!-- <button type="button" class="button is-info" @click="save(true)">{{ invoice ? 'UPDATE' : 'SAVE & ADD ANOTHER' }}</button> -->
			</div>
		</form>
	</section>
</template>
<script>
import { InvoiceService } from "@/services/invoice.service";
import debounce from "lodash/debounce";
import moment from "moment";
import TagsInput from "@/components/partials/TagsInput";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import BaseTagInput from "@/components/partials/BaseTagInput";

export default {
	components: { TagsInput, BaseTagInput },
	props: ['invoice'],
    data: () => ({
    	orderSearchKeyword: null,
    	invoiceFromKeyword: null,
    	form: {
    		invoice_id: null,
    		order_search: null,
    		approved_by: null,
    		order_number: null,
    		invoice_from: null,
    		invoice_number: null,
    		invoice_date: null,
    		invoice_value: null,
    		tags: [],
    		notes: null,
    	}, 
    	orderSearch: [],
    	invoiceFrom: [],
    }),
    computed: {
        filteredOrderSearch() {
            return this.orderSearch.filter(element => {
            	let orderSearchKeyword = this.orderSearchKeyword;
            	return orderSearchKeyword ? (element.data ? element.data.toLowerCase().includes(orderSearchKeyword.toLowerCase()) : false) : true;
            });
        },
        filteredInvoiceFrom() {
            return this.invoiceFrom.filter(element => {
            	let invoiceFromKeyword = this.invoiceFromKeyword;
            	return invoiceFromKeyword ? element.data.toLowerCase().includes(invoiceFromKeyword.toLowerCase()) : true;
            });
        },
        users() {
        	return this.filteredInvoiceFrom.length ? this.filteredInvoiceFrom[0].users : []
        },
        canManageInvoices() {
			return this.$store.getters["Auth/hasPermission"]("can manage invoices")
        }
    },
    watch: {
    	invoice(value) {
    		this.resetForm()
    		if (value) {
    			this.setForm()
    		}
    	},
    	'form.order_search'(value) {
    		if (value) {
    			let data = value.data.split(' - ');
    			this.form.order_number = data[0];
    			this.invoiceFromKeyword = data[1];
    			this.$nextTick(() => {
    				this.getInvoiceFrom(true);
    			});
    		}
    	},
    	invoiceFromKeyword(value) {
    		if (!value) {
    			this.form.invoice_from = null;
    		}
    	},
    	'form.invoice_from'(value) {
    		// if (!value) {
    		// 	this.form.approved_by = null;
    		// }
    	}
    },
    methods: {
		getOrderSearch: debounce(function() {
      		InvoiceService.orderSearch({ keyword: this.orderSearchKeyword }).then(response => {
      			this.orderSearch = response;
      		});
		}, 500),
		getInvoiceFrom: debounce(function(autoselect = false) {
      		InvoiceService.invoiceFrom({ keyword: this.invoiceFromKeyword }).then(response => {
      			this.invoiceFrom = response;
      			if (autoselect) {
      				this.form.invoice_from = response[0];
      			}
      		});
		}, 500),

		resetForm() {
			this.form = {
	    		order_search: null,
	    		approved_by: null,
	    		order_number: null,
	    		invoice_from: null,
	    		invoice_number: null,
	    		invoice_date: null,
	    		invoice_value: null,
	    		invoice_id: null,
	    		tags: [],
	    		notes: null,
    		}; 
    		this.orderSearchKeyword = null;
    		this.orderSearch = [];
    		this.invoiceFromKeyword = null;
    		this.invoiceFrom = [];
		},

		save() {
      		InvoiceService.save(this.form).then(response => {
				let invoice = JsonDenormalizer.denormalize(response)
      			this.$emit('refetch');
				this.$emit('update:invoice', invoice)
      			this.$buefy.toast.open({
	                message: this.invoice ? 'Invoice Updated' : 'New invoice created',
	                type: "is-success",
					position: "is-top-right"
	            })
      		})
		},
		setForm() {
			this.form.approved_by = this.invoice.approvedBy ? this.invoice.approvedBy.id : null;
			this.form.order_number = this.invoice.order.orderId || this.invoice.order.id
			this.form.invoice_number = this.invoice.number
			this.form.invoice_date = this.invoice.date ? new Date(moment(this.invoice.date).format("MM/DD/YYYY")) : null
			this.form.invoice_value = this.invoice.value
			this.form.notes = this.invoice.text
			this.form.invoice_id = this.invoice.id
			this.form.tags = this.invoice.tags.map(element => element.name)
			this.invoiceFromKeyword = this.invoice.order.firm.name
			this.$nextTick(() => {
				this.getInvoiceFrom(true)
			})
		}
    },
};
</script>

<style lang="scss">
.invoice-form-component {
	.invoice-form-card-header {
		padding: 17px;
	    font-size: 20px;
	}
	.card-footer {
		background-color: unset;
		padding: 17px;
		text-align: right;
	}
	.field-body label {
		width: 150px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/invoices/form.vue